import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';

function Navbar() {
  const { currentUser, logout } = useAuth();
  const { showToast } = useToast();
  const location = useLocation();
  const navigate = useNavigate();
  
  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    showToast('You have been logged out', 'info');
    navigate('/login');
  };
  
  // Get the current page from the URL path
  const currentPage = location.pathname.split('/')[1] || 'dashboard';
  
  return (
    <>
      {/* Sidebar */}
      <aside className="sidebar" id="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">Trailio Admin</div>
        </div>
        
        <nav className="sidebar-nav">
          <div className="nav-section">
            <div className="nav-section-title">MAIN</div>
            <ul className="nav-items">
              
              <li className="nav-item">
                <NavLink 
                  to="/deployment" 
                  className={({ isActive }) => 
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  <span className="nav-icon"><i className="fas fa-rocket"></i></span>
                  Deployment
                </NavLink>
              </li>
            </ul>
          </div>
          
          <div className="nav-section">
            <div className="nav-section-title">SETTINGS</div>
            <ul className="nav-items">
              <li className="nav-item">
                <a href="#" className="nav-link" onClick={handleLogout}>
                  <span className="nav-icon"><i className="fas fa-sign-out-alt"></i></span>
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </aside>
      
      {/* Header */}
      <header className="header">
        <div className="header-title">{currentPage.charAt(0).toUpperCase() + currentPage.slice(1)}</div>
        
        <div className="header-actions">
          <div className="user-menu" id="userMenu">
            <div className="user-avatar">{currentUser?.name?.charAt(0) || 'U'}</div>
            <div className="user-name">{currentUser?.name || 'User'}</div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Navbar; 